var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVideoIcon = function SvgVideoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#5D5C5C",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.478 5.26 10.74 8l-4.26 2.74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.826 14.75C12.805 13.947 15 11.233 15 8a7 7 0 0 0-7-7l1.522 1.217M6.174 1.25A6.995 6.995 0 0 0 8 15l-1.522-1.217"
  }))));
};
export default SvgVideoIcon;